import { IApplicationState } from '../../types/redux';
import { selectProductById } from '../analytics';
import { selectJsonQuery } from '../jsonQuery';

export const selectTrackingPromoDetailsById = (id: string) => (state: IApplicationState) => {
  const product = selectProductById(id)(state);
  const sc = selectJsonQuery(state);

  return {
    product,
    sc,
  };
};
